import React from 'react'
import PropTypes from 'prop-types'
import theme from 'styles/theme'
import {
  FacebookIcon,
  PinterestIcon,
  TwitterIcon,
  InstagramIcon,
  YoutubeIcon,
  TiktokIcon,
} from 'components/Icons'
import Link from 'components/Link'
import { SocialSharingWrapper, SocialSharingItem } from './SocialLinks.style'

const SocialLinks = ({
  facebookLink,
  twitterLink,
  pinterestLink,
  instagramLink,
  youtubeLink,
  tiktokLink,
}) => {
  const facebookItem = {
    name: 'Facebook',
    src: <FacebookIcon color={theme.colors.sagemedium} />,
    link: facebookLink,
  }
  const pinterestItem = {
    name: 'Pinterest',
    src: <PinterestIcon color={theme.colors.sagemedium} />,
    link: pinterestLink,
  }
  const twitterItem = {
    name: 'Twitter',
    src: <TwitterIcon color={theme.colors.sagemedium} />,
    link: twitterLink,
  }
  const instagramItem = {
    name: 'Instagram',
    src: <InstagramIcon color={theme.colors.sagemedium} />,
    link: instagramLink,
  }
  const youtubeItem = {
    name: 'YouTube',
    src: <YoutubeIcon color={theme.colors.sagemedium} />,
    link: youtubeLink,
  }
  const tiktokItem = {
    name: 'TikTok',
    src: <TiktokIcon color={theme.colors.sagemedium} />,
    link: tiktokLink,
  }
  const socialItems = [
    facebookItem,
    instagramItem,
    twitterItem,
    pinterestItem,
    youtubeItem,
    tiktokItem,
  ]

  // If there is no social links at all - do not show the component
  if (!socialItems.find((item) => item.link)) {
    return null
  }

  return (
    <SocialSharingWrapper as="ul">
      {socialItems.map(({ name, link, src }) =>
        link ? (
          <SocialSharingItem as="li" key={name}>
            <Link title={`${name}`} to={link} external>
              {src}
            </Link>
          </SocialSharingItem>
        ) : null
      )}
    </SocialSharingWrapper>
  )
}

SocialLinks.propTypes = {
  facebookLink: PropTypes.string,
  twitterLink: PropTypes.string,
  pinterestLink: PropTypes.string,
  instagramLink: PropTypes.string,
  youtubeLink: PropTypes.string,
  tiktokLink: PropTypes.string,
}

SocialLinks.defaultProps = {
  facebookLink: '',
  twitterLink: '',
  pinterestLink: '',
  instagramLink: '',
  youtubeLink: '',
  tiktokLink: '',
}

export default SocialLinks
